enum TravelOption {
  HOTELS = 'H',
  FLIGHTS_HOTELS = 'FH',
  FLIGHTS = 'F',
  CARS = 'CA',
  CRUISES = 'CR',
  ACTIVITIES = 'A',
}

export { TravelOption };
